const state = {
  unsavedChanges: false
}

const mutations = {
  setUnsavedChanges(state, hasChanges) {
    state.unsavedChanges = hasChanges;
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/unsavedChangesStore.js